import { formatDate3 } from "./../function";

const SmsR = ({ dt }) => {
    const isOperator = (phone) => {
        if (!phone) return '';
        if (phone.startsWith('034') || phone.startsWith('038') || phone.toLowerCase().includes('mvola')) return 'telma';
        if (phone.startsWith('032') || phone.startsWith('037') || phone.toLowerCase().includes('orange')) return 'orange';
        if (phone.startsWith('033') || phone.toLowerCase().includes('airtel')) return 'airtel';
        return '';
    };

    const op = isOperator(dt.phone);
    const opColors = {
        telma:  { bg: '#e8f5e9', color: '#2e7d32' },
        orange: { bg: '#fff3e0', color: '#e65100' },
        airtel: { bg: '#ffebee', color: '#c62828' },
    };
    const opStyle = opColors[op] || { bg: '#f5f5f5', color: '#5a5a5a' };

    return (
        <tr>
            <td>
                <span style={{ fontWeight: 600, fontSize: '13px', color: '#1e3a5f' }}>
                    {dt.passerelle?.name || '—'}
                </span>
            </td>
            <td style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#6c757d' }}>
                {formatDate3(dt.createdAt)}
            </td>
            <td>
                <span style={{
                    display: 'inline-block',
                    padding: '2px 10px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 600,
                    background: opStyle.bg,
                    color: opStyle.color,
                }}>
                    {dt.phone}
                </span>
            </td>
            <td style={{ fontSize: '13px', maxWidth: '300px', wordBreak: 'break-word' }}>
                {dt.message}
            </td>
        </tr>
    );
};

export default SmsR;
